import { render, staticRenderFns } from "./PersonaliseFinance.vue?vue&type=template&id=b152eb22&scoped=true"
import script from "./PersonaliseFinance.vue?vue&type=script&lang=js"
export * from "./PersonaliseFinance.vue?vue&type=script&lang=js"
import style0 from "./PersonaliseFinance.vue?vue&type=style&index=0&id=b152eb22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b152eb22",
  null
  
)

export default component.exports